/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { FULL_ACTION_FRAGMENT } from '@/graphql'

export const GET_ACTION = gql`
  query GetAction($id: ID!) {
    action(id: $id) {
      ...FullAction
    }
  }
  ${FULL_ACTION_FRAGMENT}
`
